import React from 'react';
import { Link } from 'react-router-dom';

const SimpleMap = ({ driver, height = '400px' }) => {
  const formatTime = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp).toLocaleString();
  };

  if (!driver.location || !driver.location.coordinates || driver.location.coordinates.length < 2) {
    return (
      <div className="bg-gray-100 rounded-lg flex items-center justify-center" style={{ height }}>
        <div className="text-center">
          <div className="w-12 h-12 bg-gray-300 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <p className="text-gray-600">No location data available</p>
          <p className="text-sm text-gray-500 mt-2">
            Driver location is not currently available
          </p>
        </div>
      </div>
    );
  }

  const lat = driver.location.coordinates[1];
  const lng = driver.location.coordinates[0];
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${lng-0.01},${lat-0.01},${lng+0.01},${lat+0.01}&layer=mapnik&marker=${lat},${lng}`;

  return (
    <div style={{ height, width: '100%' }}>
      <iframe
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src={mapUrl}
        title="Driver Location"
        className="rounded-lg"
      />
      <div className="mt-4 p-4 bg-white rounded-lg border">
        <h4 className="font-medium text-gray-900 mb-2">Location Details</h4>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Driver:</span>
            <span className="font-medium">{driver.name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Coordinates:</span>
            <span className="font-mono text-xs">{lat.toFixed(6)}, {lng.toFixed(6)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Last Updated:</span>
            <span className="text-xs">{formatTime(driver.liveStats?.lastLocationUpdatedOn)}</span>
          </div>
          {driver.location.tripId && (
            <div className="flex justify-between">
              <span className="text-gray-600">Current Trip:</span>
              <Link 
                to={`/trips/${driver.location.tripId}`}
                className="text-primary-600 hover:text-primary-800 text-xs"
              >
                View Trip
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleMap; 